<div class="logo-navbar">
  <div class="logo-container">
    <div class="example-sidenav-content">
      <div class="navbar-mobile" (click)="openSidenav()">
        <app-icon [svgIcon]="'mobile-menu-logo'"></app-icon>
      </div>
    </div>
    <a routerLink="/" class="logo">
      <img
        class="logo-givaudan"
        src="/assets/images/logo-givaudan.webp"
        alt="logo"
        loading="lazy"
        appImgFallback="/assets/images/logo-givaudan.png" />
    </a>
  </div>
  <nav class="navbar">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          routerLink="/who-we-are"
          class="body-m nav-item__link"
          routerLinkActive="nav-item__link--is-active"
          >{{ 'header.who-we-are' | translate }}</a>
      </li>
      <li class="nav-item">
        <div
          class="body-m nav-item__link fragrances-menu"
          [matMenuTriggerFor]="fragrancesMenu">
          {{ 'header.fragrances' | translate }}
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
        <mat-menu
          #fragrancesMenu="matMenu"
          class="fragrances-header-menu"
          hasBackdrop="true">
          @for (link of fragrancesLinks; track link) {
            <div mat-menu-item (click)="goToLink('/edito/' + link.href, $event)">
              <a class="body-m">
                {{ 'simple-link-names.fragrances.' + link.name | translate }}</a>
            </div>
          }
        </mat-menu>
      </li>
      <li class="nav-item">
        <a
          class="body-m nav-item__link"
          routerLink="/trends-inspirations"
          routerLinkActive="nav-item__link--is-active">{{ 'header.trends-and-inspiration' | translate }}</a>
      </li>
      @if (accountService.user().isAuthenticated) {
        <li class="nav-item" *appFeatureToggling="'catalogue'">
          <a
            class="body-m nav-item__link"
            routerLink="/protected/fragrance-catalogue"
            routerLinkActive="nav-item__link--is-active">{{ 'header.fragrance-catalogue' | translate }}</a>
        </li>
      }
    </ul>
  </nav>
</div>
